export const GET_DEBT_REVENUE = "GET_DEBT_REVENUE"
export const GET_DEBT_REVENUE_SUCCESS = "GET_DEBT_REVENUE_SUCCESS"
export const GET_DEBT_REVENUE_FAIL = "GET_DEBT_REVENUE_FAIL"
